<template>
    <div class="se-ball" @click="selected(item,gindex,index)" :class="getUlLiClass">
        <div class="ball" :style="{backgroundColor:(item.selected? '#e32116':'#fff'),
            color:(item.selected? '#fff':'')
        }"
             :class="[(type === 1 && Number(item.class3).toString() !== 'NaN') ? '' : '']">
             {{item.class3.replace('总和','')}}</div>
        <span class="rate">{{item.odds}}</span>
    </div>
</template>



<script>
  import objectPath from 'object-path';
  export default {
    name: "se-ball",
    props: {
      type: {
        type: Number,
        default: 2
      },
      gindex: {
          type:Number,
          default:0
      },
      index: {
          type:Number,
          default:0
      },
      item: {
        type: Object,
        default () {
          return {
            rate: 19.878,
            title: 1
          }
        }
      },
      nextLottery: {
        type: Object,
        default: null
      },
    },
    computed: {
        getUlLiClass() {
            const block_time = objectPath.get(this.nextLottery, 'block_time');
            if (!block_time || (block_time && isNaN(block_time) || block_time <= 0)) {
            return 'ul_li_disabled';
            }
            return '';
        }
    },
    filters: {
      number (title) {
        return parseInt(title);
      }
    },
    methods: {
        selected(item,gindex,index){
            const block_time = objectPath.get(this.nextLottery, 'block_time');
            if (!block_time || (block_time && isNaN(block_time) || block_time <= 0)) {
                this.$toast.center("已封盘");
                return false;
            }
            this.$emit('selected', item,gindex,index)
        }
    },
  }
</script>

<style scoped lang="less">
    .se-ball{
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
     
        .ball{
            width: 76px;
            height: 76px;

            display: flex;
            font-size: 3vw;
            box-sizing: border-box;
            box-shadow: 0 1px 2px 1px #ccc;
            font-weight: bold;
            align-items: center;
            border-radius: 76px;
            justify-content: center;
   
            &.num1{
                border: 2px solid #ffff00;
            }
            &.num2{
                border: 2px solid #0089ff;
            }
            &.num3{
                border: 2px solid #4d4d4d;
            }
            &.num4{
                border: 2px solid #ff7300;
            }
            &.num5{
                border: 2px solid #81ffff;
            }
            &.num6{
                border: 2px solid #5200ff;
            }
            &.num7{
                border: 2px solid #b8b8b8;
            }
            &.num8{
                border: 2px solid #ff0000;
            }
            &.num9{
                border: 2px solid #530000;
            }
            &.num10{
                border: 2px solid #1c8800;
            }
        }
        .rate{
            font-size: 24px;
            margin-top: 15px;
        }
    }
    .ul_li_disabled div{
        background: #dddddd !important;
        cursor: not-allowed !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/se-ball/index.vue